module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "freights"
    }
  }, [_c('div', {
    staticClass: "md-layout-row header"
  }, [_c('div', {
    staticClass: "md-flex"
  }, [_c('div', {
    staticClass: "md-body-1"
  }, [_c('div', {
    staticClass: "md-layout"
  }, [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "to": {
        name: 'StorekeepersFreights'
      }
    }
  }, [_vm._v("Отмена")])], 1), _c('div', {
    staticClass: "md-layout-item md-layout md-alignment-top-right"
  }, [(_vm.freight && _vm.freight.id) ? _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.capture()
      }
    }
  }, [_vm._v("Подписать")]) : _vm._e()], 1), (!_vm.freightErrors.length && _vm.form.freight_id && _vm.debt && _vm.debt.result && (parseInt(_vm.freight.status_id) !== parseInt(_vm.issuedStatus.id))) ? _c('div', {
    staticClass: "md-layout-item md-layout md-alignment-top-right"
  }, [_c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        _vm.issue()
      }
    }
  }, [_vm._v("Выдать")])], 1) : _vm._e()]), _c('div', {
    staticClass: "md-caption debt"
  }, [(_vm.debt && _vm.debt.result) ? _c('div', {
    staticClass: "allow"
  }, [_vm._v("Отгрузка разрешена")]) : _vm._e(), (!_vm.debt || (_vm.debt && !_vm.debt.result)) ? _c('div', {
    staticClass: "deny"
  }, [_vm._v("Отгрузка запрещена")]) : _vm._e()]), (_vm.freightErrors && _vm.freightErrors.length) ? _c('div', {
    staticClass: "errors"
  }, _vm._l((_vm.freightErrors), function(error) {
    return _c('div', {
      staticClass: "error"
    }, [_vm._v(_vm._s(error))])
  })) : _vm._e(), (parseInt(_vm.freight.status_id) === parseInt(_vm.issuedStatus.id)) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Груз уже выдан клиенту")]) : _vm._e(), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('tracking')
    }
  }, [_c('label', [_vm._v("Номер отслеживания груза*")]), _c('md-input', {
    ref: "tracking",
    attrs: {
      "name": "tracking"
    },
    model: {
      value: (_vm.tracking),
      callback: function($$v) {
        _vm.tracking = $$v
      },
      expression: "tracking"
    }
  })], 1), _c('md-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freightsStatuses && _vm.freightsStatuses.length > 1),
      expression: "freightsStatuses && freightsStatuses.length > 1"
    }],
    class: {
      'md-invalid': _vm.errors.has('from_stock_id')
    }
  }, [_c('label', [_vm._v("Статус груза")]), _c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "id": "status_id",
      "name": "status_id",
      "data-vv-as": " "
    },
    model: {
      value: (_vm.form.status_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "status_id", $$v)
      },
      expression: "form.status_id"
    }
  }, _vm._l((_vm.freightsStatuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  })), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status_id')),
      expression: "errors.has('status_id')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('status_id')))])], 1), (_vm.freight && _vm.freight.id) ? _c('md-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.freight.to_signature),
      expression: "freight.to_signature"
    }],
    class: {
      'md-invalid': _vm.errors.has('to_signature'),
      'md-has-value': !!_vm.freight.to_signature
    }
  }, [_c('label', [_vm._v("Подпись получателя")]), _c('wacom-signature', {
    ref: "signature",
    on: {
      "capture-complete": _vm.onCapture,
      "capture-cancel": _vm.onCaptureCancel
    },
    model: {
      value: (_vm.freight.to_signature),
      callback: function($$v) {
        _vm.$set(_vm.freight, "to_signature", $$v)
      },
      expression: "freight.to_signature"
    }
  })], 1) : _vm._e(), (_vm.freight && _vm.freight.id) ? _c('div', [_c('display-value', {
    attrs: {
      "inline": true,
      "value": (_vm.freight.traking_number),
      "label": 'Номер отслеживания'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.status_id) ? _vm.freight.status.name : 'Не установлен'),
      "label": 'Статус'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": (_vm.freight.weight + ' кг.'),
      "label": 'Вес'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.departure_date) ? _vm.moment(_vm.freight.departure_date, 'YYYY-MM-DD HH:ss:mm').format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна'),
      "label": 'Дата забора'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": (_vm.freight.size + ' ' + _vm.freight.size_units + '.'),
      "label": 'Объём'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.doom) ? 'Да' : 'Нет'),
      "label": 'Обрешётка'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": (_vm.freight.price + ' руб.'),
      "label": 'Цена'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.factory_package) ? 'Да' : 'Нет'),
      "label": 'Заводская упаковка'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.oversized) ? 'Да' : 'Нет'),
      "label": 'Негабаритный груз'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.seats_number) ? _vm.freight.seats_number : 'Не установленно'),
      "label": 'Количество мест'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.forwarder_id) ? _vm.freight.forwarder.login : 'Не установлен'),
      "label": 'Ответственный экспедитор'
    }
  }), _c('display-value', {
    attrs: {
      "inline": true,
      "value": ((_vm.freight.description) ? _vm.freight.description : 'Не установленно'),
      "label": 'Описание'
    }
  })], 1) : _vm._e(), (_vm.freight && _vm.freight.deal && _vm.freight.deal.id && _vm.freight.deal.recipient_id) ? _c('toggle-card', {
    staticClass: "recipient-card",
    attrs: {
      "visibility": _vm.showRecipient,
      "heading": "Данные получателя"
    }
  }, [_c('recipient', {
    ref: "recipient",
    attrs: {
      "id": parseInt(_vm.freight.deal.recipient_id),
      "deal_id": parseInt(_vm.freight.deal.id)
    }
  })], 1) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb6fe1e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/IssueFreight.vue
// module id = 1273
// module chunks = 0